import { Directive, HostListener } from "@angular/core";
import screenfull from "screenfull";

@Directive({ selector: "[myToggleFullscreen]" })
export class ToggleFullscreenDirective {

    @HostListener("click")
    onClick() {
        // HACK: This should be behind a service in the event the library changes
        if (screenfull.isEnabled) {
            screenfull.toggle();
        }
    }

}
